// These are the fields required for upload of stakeholders

export type FieldType = {
  label: string;
  key: string;
  description?: string;
  validators?: {
    validate: string;
    error: string;
    regex?: string;
    fields?: string[];
  }[];
  type?: string;
};

export const commonPeopleFields: FieldType[] = [
  { type: 'string', label: 'Type', key: 'type', description: 'Stakeholder type' },
  { type: 'string', label: 'Name', key: 'name', description: 'name' },
  { type: 'string', label: 'First Name', key: 'firstName', description: 'First Name' },
  { type: 'string', label: 'Surname', key: 'lastName', description: 'Surname' },
  { type: 'string', label: 'National ID', key: 'nationalID', description: 'National ID number' },
  { type: 'string', label: 'Date of Birth', key: 'dateOfBirth', description: "The stakeholder's date of birth" },
  { type: 'string', label: 'Population group', key: 'populationGroup', description: 'Population group' },
  { type: 'string', label: 'Home Language', key: 'homeLanguage', description: 'Home Language' },
  { type: 'string', label: 'Gender', key: 'gender', description: 'Gender' },
  { type: 'string', label: 'Contact Number', key: 'contactNumber', description: 'Contact Number' },
  {
    type: 'string',
    label: 'Email Address',
    key: 'emailAddress',
    description: 'Email',
    // validators: [
    //   {type:'string',
    //     validate: 'regex_matches',
    //     regex: '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$',
    //     error: 'Must be a valid email',
    //   },
    // ],
  },
  {
    type: 'string',
    label: 'Primary Institution',
    key: 'primaryInstitution',
    description: 'Primary Institution',
    // validators: [
    //   {type:'string',
    //     validate: 'required',
    //     error: 'must be present',
    //   },
    // ],
  },
  {
    type: 'string',
    label: 'Primary Start Date',
    key: 'primaryStartDate',
    // validators: [{type:'string', validate: 'required', error: 'must be present ' }],
  },
  {
    type: 'string',
    label: 'Primary End Date',
    key: 'primaryEndDate',
    // validators: [{type:'string', validate: 'required', error: 'must be present ' }],
  },
  {
    type: 'string',
    label: 'Additional Institution(s)',
    key: 'additionalInstitution',
    description: 'Additional Institution(s)',
  },
  { type: 'string', label: 'Additional Start Date(s)', key: 'additionalStartDate' },
  { type: 'string', label: 'Additional End Date(s)', key: 'additionalEndDate' },
];

export const districtOfficialsFields: FieldType[] = [
  { type: 'string', label: 'Persal Number', key: 'persalNumber', description: 'Persal Number' },
  { type: 'string', label: 'Personnel Position', key: 'personnelPosition', description: 'Personnel Position' },
  {
    type: 'string',
    label: 'Personnel Position Other',
    key: 'personnelPositionOther',
    description: 'Personnel Position Other',
  },
  { type: 'string', label: 'Phase', key: 'phase', description: 'Phase' },
  { type: 'string', label: 'Subject Code', key: 'subject', description: 'Subject Code' },
  { type: 'string', label: 'Designation', key: 'designation', description: 'Designation' },
  { type: 'string', label: 'Date Exited', key: 'dateExited', description: 'Date Exited' },
  { type: 'string', label: 'Reason for Exit', key: 'termination', description: 'Reason for Exit' },
];

export const socialServicesProfessionalsFields: FieldType[] = [
  { type: 'string', label: 'Persal Number', key: 'persalNumber', description: 'Persal Number' },
  { type: 'string', label: 'Personnel Position', key: 'personnelPosition', description: 'Personnel Position' },
  {
    type: 'string',
    label: 'Personnel Position Other',
    key: 'personnelPositionOther',
    description: 'Personnel Position Other',
  },
  { type: 'string', label: 'Designation', key: 'designation', description: 'Designation' },
  { type: 'string', label: 'Date Exited', key: 'dateExited', description: 'Date Exited' },
  { type: 'string', label: 'Reason for Exit', key: 'termination', description: 'Reason for Exit' },
];

export const communityMemberFields: FieldType[] = [
  { type: 'string', label: 'Community Type', key: 'communityType', description: 'Community Type' },
  { type: 'string', label: 'Country', key: 'country', description: 'Country' },
  { type: 'string', label: 'Province', key: 'province', description: 'Province' },
  { type: 'string', label: 'District', key: 'district', description: 'District' },
  { type: 'string', label: 'Local Municipality', key: 'localMunicipality', description: 'Local Municipality' },
  { type: 'string', label: 'Role', key: 'role', description: 'Role' },
  { type: 'string', label: 'Date Exited', key: 'dateExited', description: 'Date Exited' },
  { type: 'string', label: 'Reason for Exit', key: 'termination', description: 'Reason for Exit' },
];

export const provincialOfficialsFields: FieldType[] = [
  { type: 'string', label: 'Persal Number', key: 'persalNumber', description: 'Persal Number' },
  { type: 'string', label: 'Country', key: 'country', description: 'Country' },
  { type: 'string', label: 'Province', key: 'province', description: 'Province' },
  { type: 'string', label: 'Region', key: 'region', description: 'Region' },
  { type: 'string', label: 'Branch', key: 'branch', description: 'Branch' },
  { type: 'string', label: 'Personnel Position', key: 'personnelPosition', description: 'Personnel Position' },
  {
    type: 'string',
    label: 'Personnel Position Other',
    key: 'personnelPositionOther',
    description: 'Personnel Position Other',
  },
  { type: 'string', label: 'Role', key: 'role', description: 'Role' },
  { type: 'string', label: 'Other Role', key: 'otherRole', description: 'Other Role' },
  { type: 'string', label: 'Designation', key: 'designation', description: 'Designation' },
  { type: 'string', label: 'Date Exited', key: 'dateExited', description: 'Date Exited' },
  { type: 'string', label: 'Reason for Exit', key: 'termination', description: 'Reason for Exit' },
];

export const nationalOfficialsFields: FieldType[] = [
  { type: 'string', label: 'Personnel Position', key: 'personnelPosition', description: 'Personnel Position' },
  {
    type: 'string',
    label: 'Personnel Position Other',
    key: 'personnelPositionOther',
    description: 'Personnel Position Other',
  },
  { type: 'string', label: 'Persal Number', key: 'persalNumber', description: 'Persal Number' },
  { type: 'string', label: 'Country', key: 'country', description: 'Country' },
  { type: 'string', label: 'Branch', key: 'branch', description: 'Branch' },
  { type: 'string', label: 'Designation', key: 'designation', description: 'Designation' },
  { type: 'string', label: 'Date Exited', key: 'dateExited', description: 'Date Exited' },
  { type: 'string', label: 'Reason for Exit', key: 'termination', description: 'Reason for Exit' },
];

export const learnersFields: FieldType[] = [
  { type: 'string', label: 'System ID', key: 'id', description: 'System ID' },
  {
    type: 'string',
    label: 'FirstName',
    key: 'firstName',
    description: "The person's first name",
    // validators: [{type:'string', validate: 'required_without', fields: ['lastName'], error: 'Name or Surname is required' }],
  },
  {
    type: 'string',
    label: 'Surname',
    key: 'lastName',
    description: 'Surname',
    // validators: [{type:'string', validate: 'required_without', fields: ['firstName'], error: 'Name or Surname is required' }],
  },
  { type: 'string', label: 'InstitutionId', key: 'institutionId', description: 'InstitutionId' },
  { type: 'string', label: 'National ID', key: 'nationalID', description: 'National ID number' },
  { type: 'string', label: 'Date of Birth', key: 'dateOfBirth', description: "The stakeholder's date of birth" },
  { type: 'string', label: 'Population group', key: 'populationGroup', description: 'Population group' },
  { type: 'string', label: 'Home Language', key: 'homeLanguage', description: 'Home Language' },
  { type: 'string', label: 'Contact Number', key: 'contactNumber', description: 'Contact Number' },
  {
    type: 'string',
    label: 'Email Address',
    key: 'emailAddress',
    description: 'Email',
    // validators: [
    //   {type:'string',
    //     validate: 'regex_matches',
    //     regex: '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$',
    //     error: 'Must be a valid email',
    //   },
    // ],
  },
  { type: 'string', label: 'District', key: 'district', description: 'District' },

  { type: 'string', label: 'Local Municipality', key: 'localMunicipality', description: 'Local Municipality' },
  { type: 'string', label: 'Ward Label', key: 'wardLabel', description: 'Ward Label' },
  { type: 'string', label: 'Emis Number', key: 'emisNumber', description: 'Emis Number' },
  { type: 'string', label: 'Tracking Code', key: 'trackingCode', description: 'Tracking Code' },

  {
    type: 'string',
    label: 'Identification Type',
    key: 'identificationType',
    description: 'Identification Type',
  },
  {
    type: 'string',
    label: 'Tracking ID / Admission Number',
    key: 'trackingId',
    description: 'Tracking ID / Admission Number',
  },
  { type: 'string', label: 'Gender', key: 'gender', description: 'Gender' },
  { type: 'string', label: 'Passport Number', key: 'passport', description: 'Passport Number' },
  { type: 'string', label: 'Institution', key: 'institution', description: 'Institution' },
  { type: 'string', label: 'Citizenship', key: 'citizenshipId', description: 'Citizenship' },
  {
    type: 'string',
    label: 'Birth Certificate / ID',
    key: 'birthCertificateOrId',
    description: 'Birth Certificate / ID',
  },
  {
    type: 'string',
    label: 'Applied for Birth Certificate / ID',
    key: 'appliedForBirthCertificateOrId',
    description: 'Applied for Birth Certificate / ID',
  },
  { type: 'string', label: 'Study Permit', key: 'studyPermit', description: 'Study Permit' },
  { type: 'string', label: 'Study Permit Number', key: 'studyPermitNumber', description: 'Study Permit Number' },
  {
    type: 'string',
    label: 'Reason for Lack of Birth Certificate / ID',
    key: 'reasonForLackOfBirthCertificateOrId',
    description: 'Reason for Lack of Birth Certificate / ID',
  },
  { type: 'string', label: 'Road to Health Card', key: 'roadtoHealthCard', description: 'Road to Health Card' },
  {
    type: 'string',
    label: 'Reason for Lack of Road to Health Card',
    key: 'reasonForLackOfRoadToHealthCard',
    description: 'Reason for Lack of Road to Health Card',
  },

  { type: 'string', label: 'Special Needs', key: 'specialNeeds', description: 'Special Needs' },
  {
    type: 'string',
    label: 'Orphaned / Vulnerable Child',
    key: 'ovc',
    description: 'Orphaned / Vulnerable Child',
  },
  {
    type: 'string',
    label: 'Receiving Social Grant',
    key: 'receivingSocialGrant',
    description: 'Receiving Social Grant',
  },
  { type: 'string', label: 'Grant Type', key: 'grantType', description: 'Grant Type' },
  { type: 'string', label: 'Registration Date', key: 'dateStarted', description: 'Registration Date' },

  { type: 'string', label: 'Caregiver Type1', key: 'careGiverType1', description: 'Caregiver Type1' },
  {
    type: 'string',
    label: 'Caregiver Relationship1',
    key: 'careGiverRelationship1',
    description: 'Caregiver Relationship1',
  },
  { type: 'string', label: 'Caregiver Name1', key: 'careGiverName1', description: 'Caregiver Name1' },
  { type: 'string', label: 'Caregiver Surname1', key: 'careGiverSurname1', description: 'Caregiver Surname1' },
  { type: 'string', label: 'Caregiver Gender1', key: 'careGiverGender1', description: 'Caregiver Gender1' },
  {
    type: 'string',
    label: 'Caregiver Citizenship1',
    key: 'caregiverCitizenshipId1',
    description: 'Caregiver Citizenship1',
  },
  {
    type: 'string',
    label: 'Caregiver Identification Type1',
    key: 'caregiverIdentificationType1',
    description: 'Caregiver Identification Type1',
  },
  {
    type: 'string',
    label: 'Caregiver Passport Number1',
    key: 'caregiverPassport1',
    description: 'Caregiver Passport Number1',
  },
  {
    type: 'string',
    label: 'Caregiver National ID1',
    key: 'careGiverNationalId1',
    description: 'Caregiver National ID1',
  },
  {
    type: 'string',
    label: 'Caregiver Marital Status1',
    key: 'careGiverMaritalStatus1',
    description: 'Caregiver Marital Status1',
  },
  {
    type: 'string',
    label: 'Caregiver Country Code1',
    key: 'caregiverCountryCode1',
    description: 'Caregiver Country Code1',
  },
  {
    type: 'string',
    label: 'Caregiver Contact Number1',
    key: 'careGiverContactNumber1',
    description: 'Caregiver Contact Number1',
  },

  {
    type: 'string',
    label: 'Caregiver Email Address1',
    key: 'careGiverEmailAddress1',
    description: 'Caregiver Email Address1',
  },
  {
    type: 'string',
    label: 'Caregiver Physical Address1',
    key: 'careGiverPhysicalAddress1',
    description: 'Caregiver Physical Address1',
  },
  { type: 'string', label: 'Employment Status1', key: 'employmentStatus1', description: 'Employment Status1' },
  {
    type: 'string',
    label: 'Caregiver Occupation1',
    key: 'careGiverOccupation1',
    description: 'Caregiver Occupation1',
  },
  {
    type: 'string',
    label: 'Caregiver Occupation: Other1',
    key: 'careGiverOccupationOther1',
    description: 'Caregiver Occupation: Other1',
  },
  {
    type: 'string',
    label: 'Caregiver Employer1',
    key: 'careGiverEmployer1',
    description: 'Caregiver Employer1',
  },
  { type: 'string', label: 'Monthly Income1', key: 'monthlyIncome1', description: 'Monthly Income1' },

  {
    type: 'string',
    label: 'Monthly Income Range1',
    key: 'monthlyIncomeRange1',
    description: 'Monthly Income Range1',
  },
  {
    type: 'string',
    label: 'Income Source Document1',
    key: 'incomeSourceDocument1',
    description: 'Income Source Document1',
  },
  {
    type: 'string',
    label: 'Child resides with this careGiver1',
    key: 'childResidesWithThisCaregive1',
    description: 'Child resides with this careGiver1',
  },
  { type: 'string', label: 'Account Payer1', key: 'accountPayer1', description: 'Account Payer1' },
  { type: 'string', label: 'Caregiver Type2', key: 'careGiverType2', description: 'Caregiver Type2' },
  {
    type: 'string',
    label: 'Caregiver Relationship2',
    key: 'careGiverRelationship2',
    description: 'Caregiver Relationship2',
  },
  { type: 'string', label: 'Caregiver Name2', key: 'careGiverName2', description: 'Caregiver Name2' },
  { type: 'string', label: 'Caregiver Surname2', key: 'careGiverSurname2', description: 'Caregiver Surname2' },
  { type: 'string', label: 'Caregiver Gender2', key: 'careGiverGender2', description: 'Caregiver Gender2' },
  {
    type: 'string',
    label: 'Caregiver Citizenship2',
    key: 'caregiverCitizenshipId2',
    description: 'Caregiver Citizenship2',
  },
  {
    type: 'string',
    label: 'Caregiver Identification Type2',
    key: 'caregiverIdentificationType2',
    description: 'Caregiver Identification Type2',
  },
  {
    type: 'string',
    label: 'Caregiver Passport Number2',
    key: 'caregiverPassport2',
    description: 'Caregiver Passport Number2',
  },
  {
    type: 'string',
    label: 'Caregiver National ID2',
    key: 'careGiverNationalId2',
    description: 'Caregiver National ID2',
  },
  {
    type: 'string',
    label: 'Caregiver Marital Status2',
    key: 'careGiverMaritalStatus2',
    description: 'Caregiver Marital Status2',
  },
  {
    type: 'string',
    label: 'Caregiver Country Code2',
    key: 'caregiverCountryCode2',
    description: 'Caregiver Country Code2',
  },
  {
    type: 'string',
    label: 'Caregiver Contact Number2',
    key: 'careGiverContactNumber2',
    description: 'Caregiver Contact Number2',
  },
  {
    type: 'string',
    label: 'Caregiver Email Address2',
    key: 'careGiverEmailAddress2',
    description: 'Caregiver Email Address2',
  },
  {
    type: 'string',
    label: 'Caregiver Physical Address2',
    key: 'careGiverPhysicalAddress2',
    description: 'Caregiver Physical Address2',
  },
  { type: 'string', label: 'Employment Status2', key: 'employmentStatus2', description: 'Employment Status2' },
  {
    type: 'string',
    label: 'Caregiver Occupation2',
    key: 'careGiverOccupation2',
    description: 'Caregiver Occupation2',
  },
  {
    type: 'string',
    label: 'Caregiver Occupation: Other2',
    key: 'careGiverOccupationOther2',
    description: 'Caregiver Occupation: Other2',
  },
  {
    type: 'string',
    label: 'Caregiver Employer2',
    key: 'careGiverEmployer2',
    description: 'Caregiver Employer2',
  },
  { type: 'string', label: 'Monthly Income2', key: 'monthlyIncome2', description: 'Monthly Income2' },

  {
    type: 'string',
    label: 'Monthly Income Range2',
    key: 'monthlyIncomeRange2',
    description: 'Monthly Income Range2',
  },
  {
    type: 'string',
    label: 'Income Source Document2',
    key: 'incomeSourceDocument2',
    description: 'Income Source Document2',
  },

  {
    type: 'string',
    label: 'Child resides with this careGiver2',
    key: 'childResidesWithThisCaregive2',
    description: 'Child resides with this careGiver2',
  },
  { type: 'string', label: 'Account Payer2', key: 'accountPayer2', description: 'Account Payer2' },

  { label: 'Disability', key: 'disability', description: 'Disability', type: 'string' },
  { type: 'string', label: 'Disability Type', key: 'disabilityTypes', description: 'Disability Types' },
  // {type:'string',
  //   label: 'Orphaned / Vulnerable Child',
  //   key: 'ovc',
  //   description: 'Orphaned / Vulnerable Child',
  //   type: 'string',
  // },
  {
    label: 'Pre Primary Experience',
    key: 'prePrimaryExperience',
    description: 'Pre Primary Experience',
    type: 'string',
  },
  { type: 'string', label: 'Grade', key: 'grade', description: 'Grade' },
  {
    type: 'string',
    label: 'Years in Grade',
    key: 'yearsInGrade',
    description: 'Years In Grade',
    // validators: [{type:'string', validate: 'regex_matches', regex: '(0|[1-9][0-9]*)$', error: 'must be numeric' }],
  },
  {
    type: 'string',
    label: 'Years in Phase',
    key: 'yearsInPhase',
    description: 'Years In Phase',
    // validators: [{type:'string', validate: 'regex_matches', regex: '(0|[1-9][0-9]*)$', error: 'must be numeric' }],
  },
  { type: 'string', label: 'Date Exited', key: 'dateExited', description: 'Date Exited' },
  { type: 'string', label: 'Reason for Exit', key: 'termination', description: 'Reason for Exit' },
  { type: 'string', label: 'Caregiver Type', key: 'careGiverType', description: 'Caregiver Type' },
  {
    type: 'string',
    label: 'Caregiver Relationship',
    key: 'careGiverRelationship',
    description: 'Caregiver Relationship',
  },
  { type: 'string', label: 'Caregiver Name', key: 'careGiverName', description: 'Caregiver Name' },
  { type: 'string', label: 'Caregiver Surname', key: 'careGiverSurname', description: 'Caregiver Surname' },
  { type: 'string', label: 'Caregiver Gender', key: 'careGiverGender', description: 'Caregiver Gender' },
  {
    type: 'string',
    label: 'Caregiver National ID',
    key: 'careGiverNationalId',
    description: 'Caregiver National ID',
  },
  {
    type: 'string',
    label: 'Caregiver Marital Status',
    key: 'careGiverMaritalStatus',
    description: 'Caregiver Marital Status',
  },
  {
    type: 'string',
    label: 'Caregiver Contact Number',
    key: 'careGiverContactNumber',
    description: 'Caregiver Contact Number',
  },
  {
    type: 'string',
    label: 'Caregiver Email Address',
    key: 'careGiverEmailAddress',
    description: 'Caregiver Email Address',
    // validators: [
    //   {type:'string',
    //     validate: 'regex_matches',
    //     regex: '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$',
    //     error: 'Must be a valid email',
    //   },
    // ],
  },
  {
    type: 'string',
    label: 'Caregiver Physical Address',
    key: 'careGiverPhysicalAddress',
    description: 'Caregiver Physical Address',
  },
  {
    type: 'string',
    label: 'Caregiver Occupation',
    key: 'careGiverOccupation',
    description: 'Caregiver Occupation',
  },
  { type: 'string', label: 'Caregiver Employer', key: 'careGiverEmployer', description: 'Caregiver Employer' },
  { type: 'string', label: 'Case ID', key: 'caseId', description: 'Case ID' },
  { type: 'string', label: 'Household ID', key: 'householdId', description: 'Household ID' },
  { type: 'string', label: 'Household Code', key: 'householdCode', description: 'Household Code' },
];

export const schoolOfficialsFields: FieldType[] = [
  { type: 'string', label: 'Persal Number', key: 'persalNumber', description: 'Persal Number' },
  { type: 'string', label: 'Personnel Position', key: 'personnelPosition', description: 'Personnel Position' },
  {
    type: 'string',
    label: 'Personnel Position Other',
    key: 'personnelPositionOther',
    description: 'Personnel Position Other',
  },
  {
    type: 'string',
    label: 'Post Level',
    key: 'postLevel',
    description: 'Post Level',
    // validators: [{type:'string', validate: 'regex_matches', regex: '(0|[1-9][0-9]*)$', error: 'must be numeric' }],
  },
  { type: 'string', label: 'Date Started', key: 'dateStarted', description: 'Date Started' },
  { type: 'string', label: 'Nature of Employment', key: 'natureOfEmployment', description: 'Nature of Employment' },
  { type: 'string', label: 'Renumeration Source', key: 'renumerationSource', description: 'Renumeration Source' },
  { type: 'string', label: 'Educator Level', key: 'educatorLevel', description: 'Educator Level' },
  { type: 'string', label: 'Years of Experience', key: 'yearsOfExperience', description: 'Years of Experience' },
  { label: 'Lead Educator', key: 'leadEducator', description: 'Lead Educator', type: 'string' },
  {
    type: 'string',
    label: 'ICT Skill',
    key: 'ictSkill',
    description: 'ICT Skill',
    // validators: [{type:'string', validate: 'regex_matches', regex: '(0|[1-9][0-9]*)$', error: 'must be numeric' }],
  },
  { type: 'string', label: 'Highest Qualification', key: 'highestQualification', description: 'Highest Qualification' },
  { label: 'Multigrade', key: 'multiGrade', description: 'Multigrade', type: 'string' },
  { type: 'string', label: 'Grade', key: 'grade', description: 'Grade' },
  { type: 'string', label: 'Subject Code', key: 'subject', description: 'Subject Code' },
  { type: 'string', label: 'Date Exited', key: 'dateExited', description: 'Date Exited' },
  { type: 'string', label: 'Reason for Exit', key: 'termination', description: 'Reason for Exit' },
];

export const commonAssociationFields: FieldType[] = [
  { type: 'string', label: 'System ID', key: 'id', description: 'System ID' },
  {
    type: 'string',
    label: 'FirstName',
    key: 'firstName',
    description: "The person's first name",
    // validators: [{type:'string', validate: 'required_without', fields: ['lastName'], error: 'Name or Surname is required' }],
  },
  {
    type: 'string',
    label: 'Surname',
    key: 'lastName',
    description: 'Surname',
    // validators: [{type:'string', validate: 'required_without', fields: ['firstName'], error: 'Name or Surname is required' }],
  },
  {
    type: 'string',
    label: 'Institution Name',
    key: 'institution',
    description: 'Institution Name',
    // validators: [{type:'string', validate: 'required', error: 'must be present' }],
  },
];

export const commonLearnerAssociationFields: FieldType[] = [
  { type: 'string', label: 'Grade', key: 'grade', description: 'Grade' },
];

// These are the fields required for upload of institutions
export const commonInstitutionFields: FieldType[] = [
  { type: 'string', label: 'InstitutionId', key: 'id', description: 'InstitutionId' },
  {
    type: 'string',
    label: 'Institution',
    key: 'institution',
    description: 'Institution name',
    // validators: [{type:'string', validate: 'required', error: 'must be present' }],
  },
  {
    type: 'string',
    label: 'Tracking Code',
    key: 'trackingCode',
    description: 'Tracking Code (Esp. For ECD Services)',
    // validators: [{type:'string', validate: 'unique', error: 'must be unique' }],
  },
  {
    type: 'string',
    label: 'EMIS Number',
    key: 'emisNumber',
    description: 'EMIS Number (for Schools)',
    // validators: [{type:'string', validate: 'unique', error: 'must be unique' }],
  },

  { type: 'string', label: 'Status', key: 'status', description: 'Institution Status e.g OPEN' },
  {
    type: 'string',
    label: 'Sector',
    key: 'sector',
    description: 'Education Sector e.g Independent, Farm, Public',
  },
  {
    type: 'string',
    label: 'ECD Service Type',
    key: 'ecdServiceType',
    description: 'ECD Service Type e.g ECD centre, Playgroup, etc',
  },
  {
    type: 'string',
    label: 'School Type',
    key: 'schoolType',
    description: 'School Type e.g Ordinary School, Exam Center etc',
  },
  { type: 'string', label: 'Phase', key: 'phase', description: 'School Phase e.g Primary, Secondary etc' },
  { type: 'string', label: 'Specialization', key: 'specialization', description: 'Specialization' },
  {
    type: 'string',
    label: 'Specialization Group',
    key: 'specializationGroup',
    description: 'Specialization Group e.g Technical, Agriculture etc',
  },
  {
    type: 'string',
    label: 'Open Boarding School',
    key: 'openBoardingSchool',
    description: 'Open Boarding School',
  },
  { type: 'string', label: 'Quintile', key: 'quintile', description: 'Quintile e.g 1, 2 etc' },
  { type: 'string', label: 'Year', key: 'year', description: 'Year' },
  {
    type: 'string',
    label: 'Country',
    key: 'country',
    description: 'Country',
    // validators: [{type:'string', validate: 'required', error: 'must be present' }],
  },
  { type: 'string', label: 'Province', key: 'province', description: 'Province' },
  { type: 'string', label: 'Region', key: 'region', description: 'Region' },
  { type: 'string', label: 'District', key: 'district', description: 'District' },
  { type: 'string', label: 'Circuit', key: 'circuit', description: 'Circuit' },
  {
    type: 'string',
    label: 'District Municipality',
    key: 'districtMunicipality',
    description: 'District Municipality',
  },
  { type: 'string', label: 'Local Municipality', key: 'localMunicipality', description: 'Local Municipality' },
  { type: 'string', label: 'Ward ID', key: 'wardID', description: 'Ward ID' },
  { type: 'string', label: 'Ward Label', key: 'wardLabel', description: 'Ward Label' },
  { type: 'string', label: 'Town City', key: 'townCity', description: 'Town City' },
  { type: 'string', label: 'Suburb', key: 'suburb', description: 'Suburb' },
  { type: 'string', label: 'Township Village', key: 'townshipVillage', description: 'Township Village' },
  { type: 'string', label: 'Locality', key: 'locality', description: 'Locality' },
  {
    type: 'string',
    label: 'Nearest Point of Interest',
    key: 'nearestPointOfInterest',
    description: 'Nearest Point of Interest',
  },
  { type: 'string', label: 'Point of Interest', key: 'pointOfInterest', description: 'Point of Interest' },
  { type: 'string', label: 'GIS Latitude', key: 'gisLatitude', description: 'GIS Latitude' },
  { type: 'string', label: 'GIS Longitude', key: 'gisLongitude', description: 'GIS Longitude' },
  { type: 'string', label: 'GIS Source', key: 'gisSource', description: 'GIS Source' },
  { type: 'string', label: 'NAS', key: 'nas', description: 'NAS' },
  { type: 'string', label: 'Nodal Area', key: 'nodalArea', description: 'Nodal Area' },
  { type: 'string', label: 'Street Address', key: 'streetAddress', description: 'Street Address' },
  { type: 'string', label: 'Street No', key: 'streetNo', description: 'Street No' },
  { type: 'string', label: 'Postal Address', key: 'postalAddress', description: 'Postal Address' },
  { type: 'string', label: 'Postal Code', key: 'postalCode', description: 'Postal Code' },
  {
    type: 'string',
    label: 'Office Contact Number',
    key: 'officeContactNumber',
    description: 'Office Contact Number',
  },
  {
    type: 'string',
    label: 'Office Email Address',
    key: 'officeEmailAddress',
    description: 'Office Email Address',
  },
  { type: 'string', label: 'Facsimile', key: 'facsimile', description: 'Facsimile' },
  {
    type: 'string',
    label: 'Person in Charge Designation',
    key: 'personInChargeDesignation',
    description: 'Person in Charge Designation',
  },
  {
    type: 'string',
    label: 'Person in Charge Full Name',
    key: 'personInChargeFullName',
    description: 'Person in Charge Full Name',
  },
  {
    type: 'string',
    label: 'Person in Charge Contact Number',
    key: 'personInChargeContactNumber',
    description: 'Person in Charge Contact Number',
  },
  {
    type: 'string',
    label: 'Person in Charge Email',
    key: 'personInChargeEmail',
    description: 'Person in Charge Email',
  },
  {
    type: 'string',
    label: 'Contact Person Designation',
    key: 'contactPersonDesignation',
    description: 'Contact Person Designation',
  },
  {
    type: 'string',
    label: 'Contact Person Full Name',
    key: 'contactPersonFullName',
    description: 'Contact Person Full Name',
  },
  {
    type: 'string',
    label: 'Contact Person Contact Number',
    key: 'contactPersonContactNumber',
    description: 'Contact Person Contact Number',
  },
  {
    type: 'string',
    label: 'Contact Person Email',
    key: 'contactPersonEmail',
    description: 'Contact Person Email',
  },
  {
    type: 'string',
    label: 'Alternative Contact Person Designation',
    key: 'alternativeContactPersonDesignation',
    description: 'Alternative Contact Person Designation',
  },
  {
    type: 'string',
    label: 'Alternative Contact Person Full Name',
    key: 'alternativeContactPersonFullName',
    description: 'Alternative Contact Person Full Name',
  },
  {
    type: 'string',
    label: 'Alternative Contact Person Contact Number',
    key: 'alternativeContactPersonContactNumber',
    description: 'Alternative Contact Person Contact Number',
  },
  {
    type: 'string',
    label: 'Alternative Contact Person Email',
    key: 'alternativeContactPersonEmail',
    description: 'Alternative Contact Person Email',
  },
  { type: 'string', label: 'Ownership', key: 'ownership', description: 'Ownership' },
  { type: 'string', label: 'Owner Build', key: 'ownerBuild', description: 'Owner Build' },
  { type: 'string', label: 'Owner Land', key: 'ownerLand', description: 'Owner Land' },
  { type: 'string', label: 'Private or NPO', key: 'privateOrNpo', description: 'Private or NPO' },
  { type: 'string', label: 'NPO Number', key: 'npoNumber', description: 'NPO Number' },
  { type: 'string', label: 'Section 21', key: 'section21', description: 'Section 21' },
  { type: 'string', label: 'Section 21 Function', key: 'section21Function', description: 'Section 21 Function' },
  { label: 'No Fee School', key: 'noFeeSchool', description: 'No Fee School', type: 'string' },
  {
    type: 'string',
    label: 'Funding Classification',
    key: 'fundingClassification',
    description: 'Funding Classification',
  },
  {
    label: 'Funded Through Equitable Share',
    key: 'fundedThroughEquitableShare',
    description: 'Funded Through Equitable Share',
    type: 'string',
  },
  {
    label: 'Funded Through Conditional Grant',
    key: 'fundedThroughConditionalGrant',
    description: 'Funded Through Conditional Grant',
    type: 'string',
  },
  {
    label: 'Funded Through Top-up Subsidy',
    key: 'fundedThroughTopUpSubsidy',
    description: 'Funded Through Top-up Subsidy',
    type: 'string',
  },
  {
    label: 'Assessed for Maintenance Grant',
    key: 'assessedForMaintenanceGrant',
    description: 'Assessed for Maintenance Grant',
    type: 'string',
  },
  {
    label: 'Received Maintenance Grant',
    key: 'receivedMaintenanceGrant',
    description: 'Received Maintenance Grant',
    type: 'string',
  },
  { type: 'string', label: 'Year of Receipt', key: 'yearOfReceipt', description: 'Year of Receipt' },
  { type: 'string', label: 'Year Started', key: 'yearEcdStartedOperating', description: 'Year Started' },
  { type: 'string', label: 'Legal Entity', key: 'legalEntity', description: 'Legal Entity' },
  { type: 'string', label: 'Registered as NPO', key: 'registeredAsNpo', description: 'Registered as NPO' },
  {
    type: 'string',
    label: 'Monthly Fee Range Lowest',
    key: 'monthlyFeeRangeLowest',
    description: 'Monthly Fee Range Lowest',
  },
  {
    type: 'string',
    label: 'Monthly Fee Range Highest',
    key: 'monthlyFeeRangeHighest',
    description: 'Monthly Fee Range Highest',
  },
  {
    type: 'string',
    label: 'Monthly CG Budget (Total)',
    key: 'monthlyCGBudgetTotal',
    description: 'Monthly CG Budget (Total)',
  },
  { type: 'string', label: 'Monthly ES Budget', key: 'monthlyESBudgetTotal', description: 'Monthly ES Budget' },
  {
    type: 'string',
    label: 'Registered Capacity',
    key: 'registeredCapacity',
    description: 'Registered Capacity',
  },
  { type: 'string', label: 'Number of Staff', key: 'numberOfStaff', description: 'Number of Staff' },
  {
    type: 'string',
    label: 'Number of Children Enrolled',
    key: 'numberOfChildrenEnrolled',
    description: 'Number of Children Enrolled',
  },
  {
    type: 'string',
    label: 'Age Range 0 to 18 Months',
    key: 'ageRange0To18Months',
    description: 'Age Range 0 to 18 Months',
  },
  {
    type: 'string',
    label: 'Age Range 0 to 12 Months',
    key: 'ageRange0To12Months',
    description: 'Age Range 0 to 12 Months',
  },
  {
    type: 'string',
    label: 'Age Range 18 Months to 3 Years',
    key: 'ageRange18MonthsTo3Years',
    description: 'Age Range 18 Months to 3 Years',
  },
  {
    type: 'string',
    label: 'Age Range 3 to 4 Years',
    key: 'ageRange3To4Years',
    description: 'Age Range 3 to 4 Years',
  },
  {
    type: 'string',
    label: 'Age Range 1 to 2 Years',
    key: 'ageRange1To2Years',
    description: 'Age Range 1 to 2 Years',
  },
  {
    type: 'string',
    label: 'Age Range 2 to 3 Years',
    key: 'ageRange2To3Years',
    description: 'Age Range 2 to 3 Years',
  },
  {
    type: 'string',
    label: 'Age Range 4 to 5 Years',
    key: 'ageRange4To5Years',
    description: 'Age Range 4 to 5 Years',
  },
  { label: 'Grade R Offered', key: 'gradeROffered', description: 'Grade R Offered', type: 'string' },
  {
    type: 'string',
    label: 'Age Range 5 to 6 Years',
    key: 'ageRange5To6Years',
    description: 'Age Range 5 to 6 Years',
  },
  // {type:'string',
  //   label: 'Number of Children Funded',
  //   key: 'numberOfChildrenFunded',
  //   description: 'Number of Children Funded',
  // },
  { type: 'string', label: 'New or Renewal', key: 'newOrRenewal', description: 'New or Renewal' },
  {
    type: 'string',
    label: 'Registration Status',
    key: 'registrationStatus',
    description: 'Registration Status',
  },
  { type: 'string', label: 'Issue Date', key: 'issueDate', description: 'Certificate Issue Date' },
  { type: 'string', label: 'Identified Date', key: 'identifiedDate', description: 'Identified Date' },
  { type: 'string', label: 'Identified By', key: 'identifiedBy', description: 'Identified By' },
  { type: 'string', label: 'Expiry Date', key: 'expiryDate', description: 'Certificate Expiry Date' },
  {
    type: 'string',
    label: 'Registration Office',
    key: 'registrationOffice',
    description: 'Registration Office',
  },
  { type: 'string', label: 'Exam Centre', key: 'examCentre', description: 'Exam Centre' },
  { type: 'string', label: 'Exam Number', key: 'examNumber', description: 'Exam Number' },
  { type: 'string', label: 'Ex Dept', key: 'exDept', description: 'Ex Dept' },
  { type: 'string', label: 'Paypoint Number', key: 'paypointNumber', description: 'Paypoint Number' },
  { type: 'string', label: 'Component Number', key: 'componentNumber', description: 'Component Number' },
  {
    type: 'string',
    label: 'Duplicate Reference',
    key: 'duplicateReference',
    description: 'Duplicate Reference',
  },
  { type: 'string', label: 'Duplicate Action', key: 'duplicateAction', description: 'Duplicate Action' },
  {
    type: 'string',
    label: 'Reason for Duplicate Action',
    key: 'reasonForDuplicateAction',
    description: 'Reason for Duplicate Action',
  },
  { type: 'string', label: 'New EMIS Number', key: 'newEmisNumber', description: 'New EMIS Number' },
  { label: 'Is Archived', key: 'isArchived', description: 'Is Archived', type: 'string' },
  { type: 'string', label: 'Data Source', key: 'dataSource', description: 'Data Source' },
  { type: 'string', label: 'Verified', key: 'verified', description: 'Verified' },
  { type: 'string', label: 'Validated', key: 'validated', description: 'Validated' },
  { type: 'string', label: 'Meals Provided', key: 'mealsProvided', description: 'Meals Provided' },
  { type: 'string', label: 'Food Provided', key: 'foodProvider', description: 'Food Provided' },
  {
    type: 'string',
    label: 'Food Provider: Other',
    key: 'foodProviderOther',
    description: 'Food Provider: Other',
  },
  {
    type: 'string',
    label: 'Language of learning',
    key: 'languageOfLearning',
    description: 'Language of learning',
  },
  { type: 'string', label: 'Closing time', key: 'closingTime', description: 'Closing time' },
  { type: 'string', label: 'Opening time', key: 'openingTime', description: 'Opening time' },
  { type: 'string', label: 'Aftercare', key: 'afterCareForSchoolGoing', description: 'Aftercare' },
  { type: 'string', label: 'School Name', key: 'primarySchoolName', description: 'School Name' },
  { type: 'string', label: 'School EMIS Number', key: 'primarySchoolEmis', description: 'School EMIS Number' },
  {
    type: 'string',
    label: 'School-based Service',
    key: 'isEcdServicePrimarySchoolBased',
    description: 'School-based Service',
  },
  { type: 'string', label: 'Open During Holidays', key: 'hasHolidays', description: 'Open During Holidays' },
  { type: 'string', label: 'Number of Days', key: 'numberOfDaysServiceOperate', description: 'Number of Days' },
  { type: 'string', label: 'Registration Type', key: 'registrationType', description: 'Registration Type' },
  { type: 'string', label: 'PCR Level', key: 'pcrLevel', description: 'PCR Level' },
  { type: 'string', label: 'PCR Cert. Number', key: 'certificateNumber', description: 'PCR Cert. Number' },
  {
    type: 'string',
    label: 'PCR Cert. Issue Date',
    key: 'certificateIssueDate',
    description: 'PCR Cert. Issue Date',
  },
  {
    type: 'string',
    label: 'PCR Cert. Expiry Date',
    key: 'certificateExpiryDate',
    description: 'PCR Cert. Expiry Date',
  },
  { type: 'string', label: 'Prog Cert. Number', key: 'progCertificateNumber', description: 'Prog Cert. Number' },
  {
    type: 'string',
    label: 'Prog Cert. Issue Date',
    key: 'progCertificateIssueDate',
    description: ' Prog Cert. Issue Date',
  },
  {
    type: 'string',
    label: 'Prog Cert. Expiry Date',
    key: 'progCertificateExpiryDate',
    description: 'Prog Cert. Expiry Date',
  },
  { type: 'string', label: 'Classification', key: 'classification', description: 'Classification' },
  { type: 'string', label: 'Prog Status', key: 'progStatus', description: 'Prog Status' },
  { type: 'string', label: 'Prog Level', key: 'progLevel', description: 'Prog Level' },
  { type: 'string', label: 'organisationName', key: 'organisationName', description: 'organisationName' },
  { type: 'string', label: 'networkName', key: 'networkName', description: 'networkName' },
  {
    type: 'string',
    label: 'Registration Number',
    key: 'registrationNumber',
    description: 'Registration Number',
  },
  { type: 'string', label: 'Shared', key: 'sharedBuilding', description: 'Shared' },
  { type: 'string', label: 'classrooms', key: 'numberOfClassrooms', description: 'classrooms' },
  { type: 'string', label: 'Kitchen', key: 'kitchen', description: 'Kitchen' },
  { type: 'string', label: 'Space', key: 'space', description: 'Space' },
  { type: 'string', label: 'Outdoor', key: 'outdoorPlayArea', description: 'Outdoor' },
  { type: 'string', label: 'Toilet', key: 'toilet', description: 'Toilet' },
  { type: 'string', label: 'toilets_children', key: 'toilets_children', description: 'toilets_children' },
  { type: 'string', label: 'toilets_gender', key: 'toilets_gender', description: 'toilets_gender' },
  {
    type: 'string',
    label: 'capture_toilets_total',
    key: 'capture_toilets_total',
    description: 'capture_toilets_total',
  },
  {
    type: 'string',
    label: 'count_toilets_children',
    key: 'count_toilets_children',
    description: 'count_toilets_children',
  },
  {
    type: 'string',
    label: 'count_toilets_adults',
    key: 'count_toilets_adults',
    description: 'count_toilets_adults',
  },
  { type: 'string', label: 'heating', key: 'heating', description: 'heating' },
  { type: 'string', label: 'lighting', key: 'lighting', description: 'lighting' },
  { type: 'string', label: 'cooking', key: 'cooking', description: 'cooking' },
  { type: 'string', label: 'water', key: 'water', description: 'water' },
  { type: 'string', label: 'waterother', key: 'waterother', description: 'waterother' },
  { type: 'string', label: 'potable', key: 'potable', description: 'potable' },
  { type: 'string', label: 'handwashing', key: 'handwashing', description: 'handwashing' },
  { type: 'string', label: 'count_staff_male', key: 'count_staff_male', description: 'count_staff_male' },
  { type: 'string', label: 'count_staff_female', key: 'count_staff_female', description: 'count_staff_female' },
  { type: 'string', label: 'count_staff_other', key: 'count_staff_other', description: 'count_staff_other' },
  {
    type: 'string',
    label: 'count_staff_salary_paid',
    key: 'count_staff_salary_paid',
    description: 'count_staff_salary_paid',
  },
  {
    type: 'string',
    label: 'count_staff_salary_unpaid',
    key: 'count_staff_salary_unpaid',
    description: 'count_staff_salary_unpaid',
  },
  {
    type: 'string',
    label: 'count_staff_contract_permanent',
    key: 'count_staff_contract_permanent',
    description: 'count_staff_contract_permanent',
  },
  {
    type: 'string',
    label: 'count_staff_contract_temporary',
    key: 'count_staff_contract_temporary',
    description: 'count_staff_contract_temporary',
  },
  {
    type: 'string',
    label: 'count_staff_contract_substitute',
    key: 'count_staff_contract_substitute',
    description: 'count_staff_contract_substitute',
  },
  {
    type: 'string',
    label: 'count_staff_time_full',
    key: 'count_staff_time_full',
    description: 'count_staff_time_full',
  },
  {
    type: 'string',
    label: 'count_staff_time_part',
    key: 'count_staff_time_part',
    description: 'count_staff_time_part',
  },
  {
    type: 'string',
    label: 'count_staff_cat_educator',
    key: 'count_staff_cat_educator',
    description: 'count_staff_cat_educator',
  },
  {
    type: 'string',
    label: 'count_staff_cat_practitioner',
    key: 'count_staff_cat_practitioner',
    description: 'count_staff_cat_practitioner',
  },
  {
    type: 'string',
    label: 'count_staff_cat_manager',
    key: 'count_staff_cat_manager',
    description: 'count_staff_cat_manager',
  },
  {
    type: 'string',
    label: 'count_staff_cat_support',
    key: 'count_staff_cat_support',
    description: 'count_staff_cat_support',
  },
  {
    type: 'string',
    label: 'professionals_practitioners',
    key: 'professionals_practitioners',
    description: 'professionals_practitioners',
  },
  {
    type: 'string',
    label: 'count_staff_qual_skills',
    key: 'count_staff_qual_skills',
    description: 'count_staff_qual_skills',
  },
  {
    type: 'string',
    label: 'count_staff_qual_nqf4_5',
    key: 'count_staff_qual_nqf4_5',
    description: 'count_staff_qual_nqf4_5',
  },
  {
    type: 'string',
    label: 'count_staff_qual_nqf6_9',
    key: 'count_staff_qual_nqf6_9',
    description: 'count_staff_qual_nqf6_9',
  },
  { type: 'string', label: 'funding', key: 'mainFundingSource', description: 'funding' },
  { type: 'string', label: 'fundingother', key: 'fundingother', description: 'fundingother' },
  { type: 'string', label: 'subsidy', key: 'receivesDBESubsidy', description: 'subsidy' },
  { type: 'string', label: 'confirm_subsidy', key: 'confirm_subsidy', description: 'confirm_subsidy' },
  {
    type: 'string',
    label: 'No. of Children subsidised through ES',
    key: 'numberOfChildrenFunded',
    description: 'No. of Children subsidised through ES',
  },
  {
    type: 'string',
    label: 'No. of Children subsidised through CG',
    key: 'numChildrenSubsidisedCG',
    description: 'No. of Children subsidised through CG',
  },
  {
    type: 'string',
    label: 'No. of Children subsidised through TU',
    key: 'numChildrenSubsidisedTU',
    description: 'No. of Children subsidised through Top Up Subsidy',
  },
  {
    type: 'string',
    label: 'Monthly Top Up Subsidy Total',
    key: 'monthlyTopUpSubsidyTotal',
    description: 'Monthly top up subsidy total',
  },
  {
    type: 'string',
    label: 'Infrastructure Grant Budget',
    key: 'infrastructureGrantBudget',
    description: 'Infrastructure Grant Budget',
  },
  {
    type: 'string',
    label: 'ecdEmploymentStimulus',
    key: 'ecdEmploymentStimulus',
    description: 'ecdEmploymentStimulus',
  },
  {
    type: 'string',
    label: 'dateECDESRFReceived',
    key: 'dateECDESRFReceived',
    description: 'dateECDESRFReceived',
  },
  { type: 'string', label: 'Altitude', key: 'gisAltitude', description: 'Altitude' },
  // {type:'string',
  //   label: 'sspSupervisor',
  //   key: 'sspSupervisorId',
  //   description: 'sspSupervisor',
  // },
  { type: 'string', label: 'sspSupervisor', key: 'sspSupervisor', description: 'sspSupervisor' },
  {
    type: 'string',
    label: 'SspSupervisor Email',
    key: 'sspSupervisorEmail',
    description: 'SspSupervisor Email',
  },
  // {type:'string',
  //   label: 'socialServicesProfessional',
  //   key: 'socialServicesProfessionalId',
  //   description: 'socialServicesProfessional',
  // },
  {
    type: 'string',
    label: 'socialServicesProfessional',
    key: 'socialServicesProfessional',
    description: 'socialServicesProfessional',
  },
  {
    type: 'string',
    label: 'SocialServicesProfessional Email',
    key: 'socialServicesProfessionalEmail',
    description: 'SocialServicesProfessional Email',
  },
  { type: 'string', label: 'censusDate', key: 'censusDate', description: 'censusDate' },
  { type: 'string', label: 'censusID', key: 'censusID', description: 'censusID' },
  { type: 'string', label: 'Physical Address', key: 'physicalAddress', description: 'Physical Address' },
  { type: 'string', label: 'Toilet', key: 'typesOfToilets', description: 'Toilet' },
  { type: 'string', label: 'toilets_children', key: 'childrenToilets', description: 'toilets_children' },
  { type: 'string', label: 'capture_toilets_total', key: 'numToilets', description: 'capture_toilets_total' },
];

export const studentFields: FieldType[] = [
  { type: 'string', label: 'Tracking ID', key: 'trackingId', description: 'Tracking ID' },
  { label: 'Disability', key: 'disability', description: 'Disability', type: 'string' },
  { type: 'string', label: 'Disability Type', key: 'disabilityTypes', description: 'Disability Types' },
  { type: 'string', label: 'Next of Kin Name', key: 'careGiverName', description: 'Next of Kin Name' },
  { type: 'string', label: 'Next of Kin Surname', key: 'careGiverSurname', description: 'Next of Kin Surname' },
  {
    type: 'string',
    label: 'Next of Kin National ID',
    key: 'careGiverNationalId',
    description: 'Next of Kin National ID',
  },
  {
    type: 'string',
    label: 'Next of Kin Contact Number',
    key: 'careGiverContactNumber',
    description: 'Next of Kin Contact Number',
  },
];

export const ecdRegistrationFields: FieldType[] = [
  { type: 'string', label: 'id', key: 'id', description: 'id' },
  { type: 'string', label: 'Institution', key: 'institution', description: 'Institution' },
  { type: 'string', label: 'Local Municipality', key: 'localMunicipality', description: 'Local Municipality' },
  { type: 'string', label: 'Ward Label', key: 'wardLabel', description: 'Ward Label' },
  { type: 'string', label: 'Tracking Code', key: 'trackingCode', description: 'Tracking Code' },
  { type: 'string', label: 'Emis Number', key: 'emisNumber', description: 'Emis Number' },
  { type: 'string', label: 'InstitutionId', key: 'institutionId', description: 'InstitutionId' },
  // { type: 'string', label: 'Name', key: 'name', description: 'Name' },
  { type: 'string', label: 'Registration Date', key: 'createdAt', description: 'Registration Date' },
  {
    type: 'string',
    label: 'Social Services Professional',
    key: 'socialServicesProfessional',
    description: 'socialServicesProfessional',
  },
  { type: 'string', label: 'SSP Supervisor', key: 'sspSupervisor', description: 'SSP Supervisor' },
  { type: 'string', label: 'Identified By', key: 'identifiedBy', description: 'Identified By' },

  { type: 'string', label: 'Date Identified', key: 'dateIdentified', description: 'Date Identified' },
  { type: 'string', label: 'Date Assigned', key: 'dateAssigned', description: 'Date Assigned' },
  { type: 'string', label: 'New Or Renewal', key: 'newOrRenewal', description: 'New Or Renewal' },
  { type: 'string', label: 'Registration Type', key: 'registrationType', description: 'Registration Type' },
  {
    type: 'string',
    label: 'Application Collection Type',
    key: 'applicationCollectionType',
    description: 'Application Collection Type',
  },
  { type: 'string', label: 'Date Attended', key: 'dateAttended', description: 'Date Attended' },
  { type: 'string', label: 'Date Invited', key: 'dateInvited', description: 'Date Invited' },
  { type: 'string', label: 'Date Collected', key: 'dateCollected', description: 'Date Collected' },
  {
    type: 'string',
    label: 'Application Submission Type',
    key: 'applicationSubmissionType',
    description: 'Application Submission Type',
  },
  { type: 'string', label: 'Date Submitted', key: 'dateSubmitted', description: 'Date Submitted' },
  { type: 'string', label: 'Submission Number', key: 'submissionNumber', description: 'Submission Number' },
  {
    type: 'string',
    label: 'Document Review Status',
    key: 'documentReviewStatus',
    description: 'Document Review Status',
  },
  {
    type: 'string',
    label: 'Date Submission Completed',
    key: 'dateSubmissionCompleted',
    description: 'Date Submission Completed',
  },
  {
    type: 'string',
    label: 'Assess Ecd Framework Online',
    key: 'assessEcdFrameworkOnline',
    description: 'Assess Ecd Framework Online',
  },
  { type: 'string', label: 'Application Notes', key: 'applicationNotes', description: 'Application Notes' },
  {
    type: 'string',
    label: 'Number Of Children Present',
    key: 'numberOfChildrenPresent',
    description: 'Number Of Children Present',
  },
  {
    type: 'string',
    label: 'Number Of Staff Present',
    key: 'numberOfStaffPresent',
    description: 'Number Of Staff Present',
  },
  {
    type: 'string',
    label: 'Registration Outcome',
    key: 'registrationOutcome',
    description: 'Registration Outcome',
  },
  {
    type: 'string',
    label: 'Site Assessment Outcome',
    key: 'siteAssessmentOutcome',
    description: 'Site Assessment Outcome',
  },
  {
    type: 'string',
    label: 'Date Of DSD Site Visit',
    key: 'dateOfDSDSiteVisit',
    description: 'Date Of DSD Site Visit',
  },
  {
    type: 'string',
    label: 'Date Of EHP Site Visit',
    key: 'dateOfEHPSiteVisit',
    description: 'Date Of EHP Site Visit',
  },
  {
    type: 'string',
    label: 'Date EHP Report Received',
    key: 'dateEHPReportReceived',
    description: 'Date EHP Report Received',
  },
  {
    type: 'string',
    label: 'Reason For Assessment Delay',
    key: 'reasonForAssessmentDelay',
    description: 'Reason For Assessment Delay',
  },
  {
    type: 'string',
    label: 'Other Assessment Delay Reasons',
    key: 'otherAssessmentDelayReasons',
    description: 'Other Assessment Delay Reasons',
  },
  {
    type: 'string',
    label: 'Date File Compilation Submitted',
    key: 'dateFileCompilationSubmitted',
    description: 'Date File Compilation Submitted',
  },
  {
    type: 'string',
    label: 'Programme Assessment Outcome',
    key: 'programmeAssessmentOutcome',
    description: 'Programme Assessment Outcome',
  },
  {
    type: 'string',
    label: 'prog Registration Outcome',
    key: 'progRegistrationOutcome',
    description: 'prog Registration Outcome',
  },
  { type: 'string', label: 'Approved By', key: 'approvedBy', description: 'Approved By' },
  { type: 'string', label: 'Certificate Number', key: 'certificateNumber', description: 'Certificate Number' },
  { type: 'string', label: 'Issue Date', key: 'issueDate', description: 'Issue Date' },
  { type: 'string', label: 'Expiry Date', key: 'expiryDate', description: 'Expiry Date' },
  { type: 'string', label: 'Pcr Level', key: 'pcrLevel', description: 'Pcr Level' },
  {
    type: 'string',
    label: 'Prog Certificate Number',
    key: 'progCertificateNumber',
    description: 'Prog Certificate Number',
  },

  {
    type: 'string',
    label: 'Prog Certificate IssueDate',
    key: 'progCertificateIssueDate',
    description: 'Prog Certificate IssueDate',
  },
  {
    type: 'string',
    label: 'Prog Certificate Expiry Date',
    key: 'progCertificateExpiryDate',
    description: 'Prog Certificate Expiry Date',
  },
  { type: 'string', label: 'Prog Level', key: 'progLevel', description: 'Prog Level' },
  {
    type: 'string',
    label: 'Date Certificate Received From District',
    key: 'dateCertificateReceivedFromDistrict',
    description: 'Date Certificate Received From District',
  },
  {
    type: 'string',
    label: 'Reason For Certification Delay',
    key: 'reasonForCertificationDelay',
    description: 'Reason For Certification Delay',
  },
  {
    type: 'string',
    label: 'Date Certificate Dispensed',
    key: 'dateCertificateDispensed',
    description: 'Date Certificate Dispensed',
  },
  {
    type: 'string',
    label: 'Date Prog Certificate Received From District',
    key: 'dateProgCertificateReceivedFromDistrict',
    description: 'Date Prog Certificate Received From District',
  },
  {
    type: 'string',
    label: 'Reason For Prog Certification Delay',
    key: 'reasonForProgCertificationDelay',
    description: 'Reason For Prog Certification Delay',
  },
  {
    type: 'string',
    label: 'Date Prog Certificate Dispensed',
    key: 'dateProgCertificateDispensed',
    description: 'Date Prog Certificate Dispensed',
  },
  {
    type: 'string',
    label: 'Reason For Rejection',
    key: 'reasonForRejection',
    description: 'Reason For Rejection',
  },
  {
    type: 'string',
    label: 'Prog Reason For Rejection',
    key: 'progReasonForRejection',
    description: 'Prog Reason For Rejection',
  },
  { type: 'string', label: 'Assessment Notes', key: 'assessmentNotes', description: 'Assessment Note' },
  { type: 'string', label: 'Submitted', key: 'submitted', description: 'Submitted' },
  { type: 'string', label: 'Approved', key: 'approved', description: 'Approved' },
  { type: 'string', label: 'District', key: 'district', description: 'District' },
];

export const managementFields: FieldType[] = [
  { type: 'string', label: 'Institution Id', key: 'id', description: 'Institution Id' },
  { type: 'string', label: 'Name', key: 'name', description: 'Name' },
  { type: 'string', label: 'District', key: 'district', description: 'District' },
  { type: 'string', label: 'Local Municipality', key: 'localMunicipality', description: 'Local Municipality' },
  { type: 'string', label: 'Ward Label', key: 'wardLabel', description: 'Ward Label' },
  { type: 'string', label: 'Emis Number', key: 'emisNumber', description: 'Emis Number' },
  { type: 'string', label: 'Tracking Code', key: 'trackingCode', description: 'Tracking Code' },
  { type: 'string', label: 'Province', key: 'province', description: 'Province' },
  { type: 'string', label: 'Circuit', key: 'circuit', description: 'Circuit' },
  { type: 'string', label: 'Registration Office', key: 'registrationOffice', description: 'Registration Office' },
  { type: 'string', label: 'SSP Supervisor', key: 'sspSupervisor', description: 'SSP Supervisor' },
  { type: 'string', label: 'SspSupervisor Email', key: 'sspSupervisorEmail', description: 'SspSupervisor Email' },
  {
    type: 'string',
    label: 'Social Services Professional',
    key: 'socialServicesProfessional',
    description: 'Social Services Professional',
  },
  {
    type: 'string',
    label: 'SocialServicesProfessional Email',
    key: 'socialServicesProfessionalEmail',
    description: 'SocialServicesProfessional Email',
  },
];

export const kruthamTemplateFields: FieldType[] = [
  { type: 'string', label: 'Record Nr', key: 'recordNumber' },
  { type: 'string', label: 'New Learner / Existing Learner / Re-instated Learner', key: 'learner' },
  { type: 'string', label: 'Full Names', key: 'fullName' },
  { type: 'string', label: 'Surname / Last Name', key: 'lastName' },
  { type: 'string', label: 'ID Number/ Passport Number', key: 'idOrPassportNumber' },
  { type: 'string', label: 'Date of Birth (YYYY/MM/DD)', key: 'dateOfBirth' },
  { type: 'string', label: 'Equity /Population Group', key: 'equityOrPopulationGroup' },
  { type: 'string', label: 'Household Language', key: 'houseHoldLanguage' },
  { type: 'string', label: 'Cell Phone Number and alternate if available', key: 'cellphoneNumber' },
  { type: 'string', label: 'Learner Contact Email Address', key: 'learnerEmailAddress' },
  { type: 'string', label: 'Residential Address Line1 <<Street>>', key: 'residentialAddressLine1' },
  { type: 'string', label: 'Residential Address Line2 <<Suburb>>', key: 'residentialAddressLine2' },
  { type: 'string', label: 'Residential Address Line3 <<City/Town>>', key: 'residentialAddressLine3' },
  { type: 'string', label: 'Residential Address Postal Code', key: 'residentialAddressPostalCode' },
  { type: 'string', label: 'Residential Address LOCAL Municipality', key: 'residentialAddressLocalMunicipality' },
  { type: 'string', label: 'Residential Address DISTRICT Municipality', key: 'residentialAddressDistrictMunicipality' },
  {
    type: 'string',
    label: 'Residential Address METROPOLITAN Municipality',
    key: 'residentialAddressMetropolitanMunicipality',
  },
  { type: 'string', label: 'Residential Address Province', key: 'residentialAddressProvince' },
  { type: 'string', label: 'Located within one of the Metros?  Y/N', key: 'locatedWithinOneOfMetros' },
  { type: 'string', label: 'Rural? Y/N', key: 'rural' },
  { type: 'string', label: 'Blind', key: 'blind' },
  { type: 'string', label: 'Partially sighted', key: 'partiallySighted' },
  { type: 'string', label: 'Deaf', key: 'deaf' },
  { type: 'string', label: 'Hearing Impaired/Hard of Hearing/Deafened', key: 'hearingImpaired' },
  { type: 'string', label: 'Deaf-Blind', key: 'deaf_blind' },
  { type: 'string', label: 'Neurodevelopmental/ Intellectual Disabilities', key: 'NeurodevelopmentalDisabilities' },
  { type: 'string', label: 'Psychosocial Disability', key: 'psychosocialDisability' },
  { type: 'string', label: 'Physical Disability', key: 'physicalDisability' },
  { type: 'string', label: 'Learning Programme Category', key: 'learningProgrammeCategory' },
  { type: 'string', label: 'Learning Programme Name', key: 'learningProgrammeName' },
  { type: 'string', label: 'Cohort Name/Number', key: 'CohortNameOrNumber' },
  { type: 'string', label: 'OFO Code (Upto 6 digits)', key: 'OFOCode' },
  { type: 'string', label: 'Occupational Title', key: 'occupationalTitle' },
  {
    type: 'string',
    label: "Occupation on DHET's list of Occupations in High Demand: 2018? Y/N",
    key: 'OccupationInHighDemand2018',
  },
  {
    type: 'string',
    label: "Occupation on DHET's list of Occupations in High Demand: 2020? Y/N",
    key: 'occupationInHighDemand2020',
  },
  { type: 'string', label: 'ECONOMIC SECTOR (related to the Learning Programme)', key: 'economicSector' },
  {
    type: 'string',
    label:
      'Name of Public University / Public University of Technology / Public TVET College where learner received theoretical learning',
    key: 'nameOfPublicUniversity',
  },
  { type: 'string', label: 'SAQA Qualification ID / Learnership ID', key: 'saqaQualificationId' },
  { type: 'string', label: 'NQF Level', key: 'nqfLevel' },
  { type: 'string', label: 'Learning Programme Start Date (YYYY/MM/DD)', key: 'learningProgrammeStartDate' },
  { type: 'string', label: 'Learning Programme End Date (YYYY/MM/DD)', key: 'learningProgrammeEndDate' },
  { type: 'string', label: 'Learning Site Name', key: 'learningSiteName' },
  { type: 'string', label: 'Learning Site Physical Address Line1 <<Street>>', key: 'learningSitePhysicalAddressLine1' },
  { type: 'string', label: 'Learning Site Physical Address Line2 <<Suburb>>', key: 'learningSitePhysicalAddressLine2' },
  {
    type: 'string',
    label: 'Learning Site Physical Address Line3 <<City/Town>>',
    key: 'learningSitePhysicalAddressLine3',
  },
  { type: 'string', label: 'Learning Site Physical Address Postal Code', key: 'learningSitePhysicalAddressPostalCode' },
  {
    type: 'string',
    label: 'Learning Site Physical Address LOCAL Municipality',
    key: 'learningSitePhysicalAddressLocalMunicipality',
  },
  {
    type: 'string',
    label: 'Learning Site Physical Address DISTRICT Municipality',
    key: 'learningSitePhysicalAddressDistrictMunicipality',
  },
  {
    type: 'string',
    label: 'Learning Site Physical Address METROPOLITAN Municipality',
    key: 'learningSitePhysicalAddressMetropilitanMunicipality',
  },
  { type: 'string', label: 'Learning Site Province', key: 'learningSiteProvince' },
  { type: 'string', label: 'Latitude (Decimal)', key: 'latitude' },
  { type: 'string', label: 'Longitude (Decimal)', key: 'longitude' },
  {
    type: 'string',
    label: 'Skills development initiative in response to innovation and digital technology Y/N',
    key: 'skillsDevelopmentInitiative',
  },
  { type: 'string', label: 'Site Phone Number', key: 'sitePhoneNumber' },
  { type: 'string', label: 'Contact Person Cell Phone Number', key: 'contactPersonCellPhoneNumber' },
  { type: 'string', label: 'Contact Person Email Address', key: 'contactPersonEmailAddress' },
  { type: 'string', label: 'Learner status as at 30 June 2023', key: 'learnerStatus30June2023' },
  {
    type: 'string',
    label: 'Reasons for status? (Dropped-out/Withdrawn learners only)',
    key: 'reasonsForStatus30June2023',
  },
  {
    type: 'string',
    label: 'Date of completion of training OR date of dropped-out  (YYYY/MM/DD)',
    key: 'dateOfCompletionOfTraining',
  },
  { type: 'string', label: 'Identity Document', key: 'identityDocument' },
  { type: 'string', label: 'Matric Certificate', key: 'matricCertificate' },
  { type: 'string', label: 'Proof of Residence', key: 'proofOfResidence' },
  { type: 'string', label: 'Learner status as at 30 September 2023', key: 'learnerStatus30September2023' },
  {
    type: 'string',
    label: 'Reasons for status? (Dropped-out/Withdrawn learners only)',
    key: 'reasonsForStatus30September2023',
  },
  { type: 'string', label: 'Learner status as at 31 December 2023', key: 'reasonsForStatus31December2023' },
  { type: 'string', label: 'Learner status as at 31 March 2024', key: 'learnerStatus31March2024' },
  {
    type: 'string',
    label: 'Reasons for status? (Dropped-out/Withdrawn learners only)',
    key: 'reasonsForStatus31March2024',
  },
  { type: 'string', label: 'Name of SMME / Co-operative (If Applicable)', key: 'nameOfSMME' },
  { type: 'string', label: 'Name of Constituency (If Applicable)', key: 'nameOfConstituency' },
];
